import workbookImg from "@/assets/img/workbook/workbook.webp";
import workbookEsImg from "@/assets/img/workbook/workbook-es.webp";
import workbookFrImg from "@/assets/img/workbook/workbook-fr.webp";
import { Languages } from "@/constants/languages";

export const workbookImgMap = {
    [Languages.English]: workbookImg,
    [Languages.Spanish]: workbookEsImg,
    [Languages.German]: workbookImg,
    [Languages.Portuguese]: workbookImg,
    [Languages.French]: workbookFrImg,
};
